module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAa0lEQVQ4T2NkoBAwUqifgSYGaDEwMFzD4TIMOXQXgBSsYmBgCMNiCFY5bF7AphCnwbjCAFkDyDe4XIU3EGGGgAyIYWBguIAtXPDFggEDA8MSqCZsYQKWookXKApEqkUj2QmJ5KxBk7xAkisAe0weEbf/1mMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign.png
// module id = G7Gw
// module chunks = 1